// extracted by mini-css-extract-plugin
export default {"col":"ShearSummary_col__PJ4Id","row":"ShearSummary_row__-ZJOU","flex":"ShearSummary_flex__3OxJf"};